module.exports = __webpack_public_path__ + "static/img/AdminLTELogo.28f7e31.png";